import { render, staticRenderFns } from "./SQuesFortySeven.vue?vue&type=template&id=4eb3913c&"
import script from "./SQuesFortySeven.vue?vue&type=script&lang=js&"
export * from "./SQuesFortySeven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports